var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
// DO NOT EDIT IT MANUALLY
import * as React from 'react';
const SvgSearchS = React.forwardRef((_a, ref) => {
    var { size = 24 } = _a, props = __rest(_a, ["size"]);
    props.width = undefined;
    props.height = undefined;
    const testId = '-search-s';
    const isCustomSize = typeof size === 'number';
    if (isCustomSize) {
        if (!props.style)
            props.style = {};
        props.style.width = size + 'px';
        props.style.height = size + 'px';
    }
    return (_jsx("svg", Object.assign({ ref: ref, xmlns: 'http://www.w3.org/2000/svg', width: 24, height: 24, fill: 'currentColor', viewBox: '0 0 24 24', "data-test-id": 'icon' + testId }, props, { children: _jsx("use", { href: '#snack-uikit-' + testId.substring(1) }) })));
});
export default SvgSearchS;
